module.exports = __webpack_public_path__ + "static/AI-Governance-in-2020-ffa2e9c4e0ec4ca3706455e0f35d5ab5.pdf";